import * as React from 'react';
const SvgMapMarker = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 21c-2.28 0-6-8.69-6-12 0-1.59.63-3.12 1.76-4.24A5.97 5.97 0 0 1 12 3c1.59 0 3.12.63 4.24 1.76A5.99 5.99 0 0 1 18 9c0 3.31-3.72 12-6 12m0-9a3.008 3.008 0 0 0 3-3 3.008 3.008 0 0 0-3-3c-.8 0-1.56.32-2.12.88S9 8.21 9 9s.32 1.56.88 2.12S11.21 12 12 12"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMapMarker;
